<template>
  <div class="home">
    <div class="home-hade">
      <div class="home-logo">
         <Row style="height:100%;">
          <Col style="height:100%;width:100%;">
            <!-- 顶部导航栏左边 -->
            <div class="logoText">
               陕西省文化和旅游市场常态化网络巡查监测系统
            </div>
            <!-- 导航栏中间 -->
            <div  class="menu-right">
                <div class="back">
                  <div class="left">
                     <span style="color:#fff;">
                        
                      </span>
                  </div>
                </div>
            </div>
            <!-- 顶部导航栏右 -->
            <div class="logoExit">
              <a  @click="exit" style="color:#fff;">退出</a>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <div class="home-center">
       <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {CURR_AREA_CODE } from '@/vuex/mutation-types'
import Bus from '@/utils/bus.js'

export default {
  components: {

  },
  data() {
    return {
      active: [],
      myPhoto:'',
      curGroupName:'',
      curGroupNameLast:'',
      curGroupId:'',
      curGroupIdLast:'',
      regionList: [],
      showTag:true,
    };
  },
  methods: {
    mousemove: function(index){
       
    },
    mouseleave: function () {
      
    },
    exit() {
      this.$router.push("/login");
    },
   
  },
  mounted() {
      
    
  }
};
</script>

<style lang='less' scoped>

//顶部导航左
.logoText{
  width: 34.7%;
  height: 100%;
  line-height: 70px;
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  text-align: center;
  float:left;
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif
}
//顶部导航中
.menu-right{
  width: 55%;
  height: 100%;
  font-size:18px;
  //font-weight:100;
  float:left;
  .back{
      width: 100%;
      height: 100%;
      vertical-align: middle;
      .left{
        float: left;
        margin-top: 35px;
        padding-left:0.5%;
        width: 15%;
        height: 100%;
        span{
          display: block;
          left:50%;
          float: left;
          font-weight:bold;
          font-size:16px;
        }
        .curPostion{
          display:inline-block;
          
          color:#fff;
          height: 100%;
          font-size:16px;
        }
      }
      .myMiddle{
        position:absolute;
        top: 0;
        bottom: 0;
        left:  28%;
        margin: auto;
        background:#fefefe;
        width: 2px;
        height: 55%;
      }
      .right{
        float:left;
        width: 84%;
        height: 100%;
        padding-left:1%;
        padding-right:1%;
        vertical-align: middle;
        margin-top: 30px;
      }
      .right span{
        font-size: 14px;
        color:#fff;
      }
  }
}
//顶部导航栏右
.logoExit{
  width: 5.3%;
  height: 100%;
  line-height: 70px;
  text-align: center;
  font-size: 18px;
  font-weight: blod;
  float:left;
}
//导航栏父级
.home {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .home-hade {
    position: absolute;
    width: 100%;
    height: 70px;
    top: 0;
    background:#308cee;
    .home-logo {
      width: 100%;
      height: 100%;
      background:#308cee;
    }
    .home-nav {
      width: 100%;
      height: 40%;
    }
  }
  .home-center {
    position: fixed;
    top: 110px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }
}
//顶部导航按钮
.menu-right .ivu-tag{
    display: inline-block;
    height: 30px;
    line-height: 30px;
    margin: 2px 4px 2px 0;
    padding: 0 2px;
    background:#308cee;
    border:#308cee;
    vertical-align: middle;
    opacity: 1;
    overflow: hidden;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue